"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const core_1 = require("@material-ui/core");
const Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete"));
function ComboBox(props) {
    const theme = styles_1.useTheme();
    return (react_1.default.createElement("div", { style: { position: "relative" } },
        react_1.default.createElement(core_1.Grid, { item: true },
            react_1.default.createElement(Autocomplete_1.default, { freeSolo: props.freeSolo, options: props.options, value: props.value, inputValue: props.getInputValue, id: props.id, onChange: props.onChange, onInputChange: props.onInputChange, getOptionSelected: props.getOptionSelected, defaultValue: props.defaultValue, getOptionLabel: props.getOptionLabel || ((value) => String(value)), renderInput: params => (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { InputLabelProps: {
                        style: { color: theme.palette.text.primary },
                        shrink: true,
                    }, InputProps: {
                        ...params.InputProps,
                        disableUnderline: true
                    }, helperText: props.error ? props.errorText : '', error: props.error || false, label: props.labelBefore, margin: "normal", fullWidth: true }))) }))));
}
exports.default = ComboBox;
//# sourceMappingURL=ComboBox.js.map